<template>
	<div id="app" :class="unPC()?'mobile-wapper':''" v-loading="AppLoading" element-loading-text="系统加载中，请稍后！" element-loading-spinner="el-icon-loading">
		<router-view></router-view>
	</div>
</template>

<script>
	import index from "./view/app.js";
	export default index;
</script>


// WEBPACK FOOTER //
// src/App.vue